import { jsxs as n, jsx as s } from "react/jsx-runtime";
import { S as q, a as N, b as S, T as a } from "../../../../thumb-eEg_ml10.js";
import { useState as x } from "react";
const e = {
  "slider-component": "_slider-component_1q4on_29",
  "slider-label": "_slider-label_1q4on_29",
  "slider-container-min-max": "_slider-container-min-max_1q4on_36",
  "slider-min": "_slider-min_1q4on_40",
  "slider-max": "_slider-max_1q4on_41",
  "slider-root": "_slider-root_1q4on_48",
  "slider-track": "_slider-track_1q4on_57",
  "slider-range": "_slider-range_1q4on_68",
  "dialog-overlay-show": "_dialog-overlay-show_1q4on_1",
  "dialog-content-show": "_dialog-content-show_1q4on_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1q4on_1"
}, v = 1, T = 1;
function k({
  defaultValue: o = [0, 100],
  minValue: d,
  maxValue: c,
  label: r,
  typeRange: t,
  onChange: _,
  minValueText: m,
  maxValueText: h,
  chosenRangeText: p
}) {
  const [l, g] = x(o), u = (i) => {
    g([i[0], i[1]]), _(i);
  };
  return /* @__PURE__ */ n("div", { className: e["slider-component"], children: [
    r && /* @__PURE__ */ s("p", { className: e["slider-label"], children: r }),
    /* @__PURE__ */ n("div", { className: e["slider-container-min-max"], children: [
      /* @__PURE__ */ s("p", { className: e["slider-min"], children: m }),
      /* @__PURE__ */ s("p", { className: e["slider-max"], children: h })
    ] }),
    /* @__PURE__ */ s(
      q,
      {
        className: e["slider-root"],
        value: [l[0], l[1]],
        min: d,
        max: c,
        step: v,
        onValueChange: u,
        minStepsBetweenThumbs: T,
        children: /* @__PURE__ */ n(N, { className: e["slider-track"], children: [
          /* @__PURE__ */ s(S, { className: e["slider-range"] }),
          /* @__PURE__ */ s(a, { value: l[0] }),
          /* @__PURE__ */ s(a, { value: l[1] })
        ] })
      }
    ),
    /* @__PURE__ */ n("p", { className: e["slider-chosen-range"], children: [
      p,
      ": ",
      l[0],
      " - ",
      l[1],
      " ",
      t
    ] })
  ] });
}
export {
  k as Slider
};
